import * as fromReducer from './application-configuration.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ApplicationConfiguration, ApplicationConfigurationState } from './application-configuration.state';
import { DevicesRouterStoreSelectors } from '../router';

export const selectApplicationConfigurationState = createFeatureSelector<ApplicationConfigurationState>(
  fromReducer.applicationConfigurationFeatureKey
);

export const selectApplicationConfiguration = createSelector(
  selectApplicationConfigurationState,
  fromReducer.selectAllApplicationConfigurations
);

export const selectApplicationConfigurationEntities = createSelector(
  selectApplicationConfigurationState,
  fromReducer.selectApplicationConfigurationEntities
);

export const selectApplicationConfigurationIds = createSelector(
  selectApplicationConfigurationState,
  fromReducer.selectApplicationConfigurationIds
);

export const selectApplicationConfigurationByUdid = createSelector(
  selectApplicationConfiguration,
  DevicesRouterStoreSelectors.selectUdid,
  (configurations: ApplicationConfiguration[], udid: string) =>
    configurations.filter((configuration) => configuration.udid === udid)
);

export const selectApplicationConfigurationByUdidAndBundleId = (bundleId: string) =>
  createSelector(selectApplicationConfigurationByUdid, (configurations: ApplicationConfiguration[]) =>
    configurations.find((configuration) => configuration.identifier === bundleId)
  );
